export default __webpack_public_path__ + "static/media/expense-tracker.2b4047ce.png";